import React, { useState, useEffect } from 'react';
const NotificationBar = ({ message }) => {

    return (
        <div className='NotificationBar'>
            {message}
        </div>
    )
}
export default NotificationBar;